import React, { useState } from "react";
import { login } from "../../Redux/Actions/userActions";
import { checkLoggedIn, setUserData } from "../../Redux/Actions/authAction";
import history from "../../@history";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import AuthService from "../../Service/auth-service";
import { Icon } from "@mui/material";

import {
  Button,
  CircularProgress,
  Container,
  CssBaseline,
  Grid,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import Selects from "Components/MUI_components/AutoComplete/selects";
import { fetchStockLocation } from "Redux/Actions/stockLocation";
import Loading from "Components/MUI_components/loading";
import { defaultLocation } from "Redux/Actions/defaultLocationActions";
import { company } from "titum-custom/details";
import HomeLogo from "./HomeLogo/HomeLogo";
import { openSnackbar } from "Redux/Actions/snackbarActions";
import { LOCAL_STORAGE } from "Components/Constants/LocalStorage";
import mainNavigationService from "Service/Users/mainNavigation.service";

const PREFIX = "Login";
const classes = {
  paper: `${PREFIX}-paper`,
  avatar: `${PREFIX}-avatar`,
  form: `${PREFIX}-form`,
  submit: `${PREFIX}-submit`,
};
const Root = styled("div")(({ theme }) => ({
  [`&.${classes.paper}`]: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  [`&.${classes.avatar}`]: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  [`&.${classes.form}`]: {
    width: "100%", // Fix IE 11 issue.
  },
  [`&.${classes.submit}`]: {
    margin: theme.spacing(1, 0, 2),
    height: 60,
  },
}));
const generateSessionId = () => Date.now().toString();

export default function Login() {
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem("sessionId"));

  const formRef = React.useRef(null);
  const dispatch = useDispatch();
  const { loggedInSuccess } = useSelector((state) => state.auth);
  const [loginData, setLoginData] = React.useState({
    username: "",
    password: "",
  });
  const [stockLocation, setStockLocation] = React.useState();
  const [locations, setLocations] = React.useState([]);
  const stockLocations = useSelector((state) => state.location);
  const [isLoaded, setIsLoaded] = React.useState(false);
  const [logedInUser, setLoggedInUser] = React.useState();
  const [showPopup, setShowPopup] = React.useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    AuthService.signInWithUserAndPassword(loginData)
      .then((res) => {
        console.log(res);
        setLocations(res.user.stockLocations);
        setLoggedInUser(res.user);
        setIsLoaded(true);
        
      })
      .catch((error) => {
        if (error.message !== undefined) {
          dispatch(checkLoggedIn(false));
          return dispatch(
            openSnackbar(true, "error", "Network error, reload the page.")
          );
        }
        const { loggedInError } = error;
        dispatch(openSnackbar(true, "error", loggedInError));
        return dispatch(checkLoggedIn(false));
      });
  };

  const setLoginDetails = async () => {
    localStorage.setItem(
      LOCAL_STORAGE.BIZX_LOCATION,
      JSON.stringify(stockLocation)
    );
    axios.defaults.headers.common.LocationCode = stockLocation.code;
    dispatch(defaultLocation(stockLocation));

    try {
      const res = await mainNavigationService.getNavigationByRole(
        stockLocation.pivot.roleId
      );
      console.log(res);
      const user = {
        ...logedInUser,
        role: [res.mainNavigation.name],
      };
      localStorage.setItem(
        LOCAL_STORAGE.MAIN_NAVIGATION,
        JSON.stringify(res?.mainNavigation?.mainNavigations)
      );
      localStorage.setItem(
        LOCAL_STORAGE.REPORT_NAVIGATION,
        JSON.stringify(res?.reportNavigation?.reportMainNavigations)
      );
      dispatch(setUserData(user));
      dispatch(checkLoggedIn(true));
      setShowPopup(true); // Show the popup

      const newSessionId = generateSessionId();
    localStorage.setItem("sessionId", newSessionId); // Broadcast login across tabs
    
    } catch (error) {
      if (error.message !== undefined) {
        dispatch(checkLoggedIn(false));
        return dispatch(
          openSnackbar(true, "error", "Network error, reload the page.")
        );
      }
    }
  };

  const handlePopupButtonClick = () => {
    setShowPopup(false);
    history.push("/brought-forward"); // Navigate to the BroughtForward.jsx page
  };

  return (
    <Root>
      <Grid
        container
        justifyContent="center"
        style={{ height: "80vh" }}
        alignItems="center"
      >
        <Grid item md={4} lg={4} sm={5} xs={12}>
          <Paper style={{ margin: 10, padding: "30px 0" }}>
            <Container component="main" maxWidth="xs">
              <CssBaseline />
              <div className={classes.paper}>
                <div className="img-container">
                  <HomeLogo /> <hr />{" "}
                  <p style={{ marginTop: 35, marginLeft: 10 }}>
                    {" "}
                    {company.name}
                  </p>
                </div>
                {locations.length === 0 && (
                  <form
                    className={classes.form}
                    ref={formRef}
                    onSubmit={handleSubmit}
                  >
                    <TextField
                      variant="outlined"
                      required
                      fullWidth
                      value={loginData.username}
                      onChange={(e) =>
                        setLoginData({
                          ...loginData,
                          username: e.target.value,
                        })
                      }
                      label="Username"
                      autoFocus
                    />
                    <TextField
                      variant="outlined"
                      margin="normal"
                      value={loginData.password}
                      onChange={(e) =>
                        setLoginData({
                          ...loginData,
                          password: e.target.value,
                        })
                      }
                      required
                      fullWidth
                      label="Password"
                      type="password"
                    />
                    <br />

                    <Button
                      type="submit"
                      fullWidth
                      variant="contained"
                      color="primary"
                      className={classes.submit}
                    >
                      Sign In
                    </Button>
                  </form>
                )}
              </div>

              {locations.length > 0 && (
                <div>
                  <Select
                    label="Stock Location*"
                    value={stockLocation}
                    required
                    fullWidth
                    onChange={(e) =>
                      setStockLocation({
                        ...e.target.value,
                      })
                    }
                  >
                    {locations.map((item) => (
                      <MenuItem key={item.code} value={item}>
                        {item.name} - {item.pivot?.roleId}
                      </MenuItem>
                    ))}
                  </Select>

                  <Button
                    sx={{ marginTop: 2 }}
                    fullWidth
                    variant="contained"
                    color="secondary"
                    disabled={!stockLocation}
                    onClick={setLoginDetails}
                  >
                    Set Location
                  </Button>
                </div>
              )}
            </Container>
            <Typography
              component="p"
              variant="caption"
              style={{ textAlign: "center", padding: 15 }}
            >
              Solution By Titum (PVT) Ltd.
            </Typography>
          </Paper>
        </Grid>
      </Grid>

      {/* Popup Section */}
      {showPopup && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              background: "white",
              padding: "20px",
              borderRadius: "10px",
              textAlign: "center",
              width: "300px",
            }}
          >
            <Typography variant="h6" style={{ marginBottom: "15px" }}>
              Reminder Message
            </Typography>
            <Typography variant="body1" style={{ marginBottom: "20px" }}>
              1st generate the brought forward.
            </Typography>
            <Button
              variant="contained"
              color="primary"
              onClick={handlePopupButtonClick}
            >
              Go to Generate
            </Button>
          </div>
        </div>
      )}
    </Root>
  );
}
